module.exports = __webpack_public_path__ + "media/images/products/category/sm/1-41711ad562bc7ab2dab55bae5479a264.jpg";